'use client';

/* eslint-disable prettier/prettier */
var translations = {
    Apply: 'Áp dụng',
    'Clear all': 'Xóa tất cả',
    Cancel: 'Hủy',
    Search: 'Tìm kiếm',
    'No result': 'Không có kết quả'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
